// const inputField = document.getElementById('searchInput');
// const staticText = 'Search by ';
// const placeholders = ['Model...','Brand...', 'Part #...','Keyword...'];
// let currentPlaceholder = 0;
// let index = 0;
// let typing = true;

// function typePlaceholder() {
//   if (typing) {
//     if (index < placeholders[currentPlaceholder].length) {
//       inputField.setAttribute('placeholder', staticText + placeholders[currentPlaceholder].substring(0, index + 1));
//       index++;
//       setTimeout(typePlaceholder, 200);
//     } else {
//       typing = false;
//       setTimeout(typePlaceholder, 1000);  
//     }
//   } else {
//     if (index > 0) {
//       inputField.setAttribute('placeholder', staticText + placeholders[currentPlaceholder].substring(0, index - 1));
//       index--;
//       setTimeout(typePlaceholder, 200);
//     } else {
//       typing = true;
//       currentPlaceholder = (currentPlaceholder + 1) % placeholders.length;
//       setTimeout(typePlaceholder, 5000);  
//     }
//   }
// }

// typePlaceholder();


$('.badges-sliders').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
    responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
      }
    }
  ]
});





